import { render, staticRenderFns } from "./valuationManagement.vue?vue&type=template&id=580cd89c&scoped=true"
import script from "./valuationManagement.vue?vue&type=script&lang=js"
export * from "./valuationManagement.vue?vue&type=script&lang=js"
import style0 from "./valuationManagement.vue?vue&type=style&index=0&id=580cd89c&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580cd89c",
  null
  
)

export default component.exports